import './vlnBackImage.scss';

export const VlnBackImageModule = angular
    .module('app.directives.vlnBackImg', [])
    .directive('vlnBackImg', () => {
        return {
            restrict: 'A',
            link: (scope, ele, attrs) => {
                attrs.$observe('vlnBackImg', (val) => {
                    ele.css({
                        'background-image': `url(${val})`,
                        'background-size': 'cover',
                        'background-position': '50% 50%'
                    });
                });
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/directives/vlnBackImage.directive.js